import { LotCompactionLevelItem } from './LotCompactionLevelItem'
import { LotMessageOptions, TestMessageOptions } from './types'

export const Lot = new LotCompactionLevelItem({
  id: '0e6e5ffe-efaf-4f3e-a263-5b8f8f352823',
  label: 'Lot',
  description:
    "If the Average Compaction of the Lot is less than the Material Requirement's Lot Compaction Requirement, issue an Identified Field Issue using the Message. Messages will always be followed by the actual and expected values.",
  levelMessage: ({ message, actual, expected }: LotMessageOptions) =>
    `${message}. Actual: ${actual}, Expected: ${expected}`,
})

export const Test = new LotCompactionLevelItem({
  id: 'e458710a-a711-49d5-902e-15cd25e55758',
  label: 'Test',
  description:
    "If the Average Percent of one or more Density Tests associated with the Lot is less than the Material Requirement's Lot Compaction Requirement, issue an Identified Field Issue using the Message. Messages will always be followed by the actual and expected values.",
  levelMessage: ({ message, expected, failed }: TestMessageOptions) => {
    const resolved = Array.isArray(failed) ? failed : [failed]
    return `${message}. ${resolved
      .map(
        ({ testId, actual }) =>
          `Test ID: ${
            testId ?? 'N/A'
          }, Actual: ${actual}, Expected: ${expected}`
      )
      .join('. ')}`
  },
})
